import script from "./ExpenseManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseManagement.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__